import { render, staticRenderFns } from "./privateClassCreate.vue?vue&type=template&id=689905d0"
import script from "./privateClassCreate.vue?vue&type=script&lang=js"
export * from "./privateClassCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports